import urljoin from 'url-join';

export const UPLOAD_BATCH_METHOD = {
  file_upload: 'file_upload',
  ftp_upload: 'ftp_upload',
  // api: 'api',
};

export const UPLOAD_BATCH_METHOD_ACTION = {
  [UPLOAD_BATCH_METHOD['file_upload']]: 'Re-upload',
  [UPLOAD_BATCH_METHOD['ftp_upload']]: 'Re-fetch',
};

export const UPLOAD_BATCH_LABEL = {
  [UPLOAD_BATCH_METHOD.file_upload]: 'File Upload',
  [UPLOAD_BATCH_METHOD.ftp_upload]: 'FTP Upload',
  // [UPLOAD_BATCH_METHOD.api]: 'API Integration',
};

export const UPLOAD_BATCH_DATA_TYPE = {
  cert: 'cert',
  cb: 'cb',
};

export const UPLOAD_BATCH_DATA_TYPE_LABEL = {
  [UPLOAD_BATCH_DATA_TYPE.cert]: 'Certification',
  [UPLOAD_BATCH_DATA_TYPE.cb]: 'Certification Body',
};

export const UPLOAD_BATCH_PROCESS_STATE = {
  upload: 'upload', // uploaded, uploading
  validation: 'validation', // validating, validated, failed, cancelled
  ready_for_import: 'ready_for_import',
  import: 'import', // importing, import, partially_imported, failed
  // verification: 'verification', // WE DON'T USE
  // configuration: 'configuration',  // WE DON'T USE
};

export const UPLOAD_FILE_STATUS = {
  pending: 'pending',
  uploading: 'uploading',
  uploaded: 'uploaded',
  validating: 'validating',
  validated: 'validated',
  importing: 'importing',
  imported: 'imported',
  cancelled: 'cancelled',
  failed: 'failed',
  partially_imported: 'partially_imported',
  ready_for_import: 'ready_for_import',
};

export const UPLOAD_FILE_STATUS_LABEL = {
  [UPLOAD_FILE_STATUS.pending]: 'Not Started',
  [UPLOAD_FILE_STATUS.uploading]: 'Uploading',
  [UPLOAD_FILE_STATUS.uploaded]: 'Uploaded',
  [UPLOAD_FILE_STATUS.validating]: 'Validating',
  [UPLOAD_FILE_STATUS.validated]: 'Validated',
  [UPLOAD_FILE_STATUS.importing]: 'Importing',
  [UPLOAD_FILE_STATUS.imported]: 'Imported',
  [UPLOAD_FILE_STATUS.cancelled]: 'Cancelled',
  [UPLOAD_FILE_STATUS.failed]: 'Failed',
  [UPLOAD_FILE_STATUS.partially_imported]: 'Partially imported',
};

export const UPLOAD_FILE_STATUS_COLOR = {
  [UPLOAD_FILE_STATUS.pending]: 'secondary',
  [UPLOAD_FILE_STATUS.uploading]: 'secondary',
  [UPLOAD_FILE_STATUS.uploaded]: 'success',
  [UPLOAD_FILE_STATUS.validating]: 'secondary',
  [UPLOAD_FILE_STATUS.validated]: 'success',
  [UPLOAD_FILE_STATUS.importing]: 'secondary',
  [UPLOAD_FILE_STATUS.imported]: 'success',
  [UPLOAD_FILE_STATUS.cancelled]: 'danger',
  [UPLOAD_FILE_STATUS.failed]: 'danger',
};

// temporary status percentage
export const UPLOAD_FILE_STATUS_PERCENT = {
  [UPLOAD_FILE_STATUS.pending]: 0,
  [UPLOAD_FILE_STATUS.uploading]: 0,
  [UPLOAD_FILE_STATUS.uploaded]: 100,
  [UPLOAD_FILE_STATUS.validating]: 0,
  [UPLOAD_FILE_STATUS.validated]: 100,
  [UPLOAD_FILE_STATUS.importing]: 0,
  [UPLOAD_FILE_STATUS.imported]: 100,
  [UPLOAD_FILE_STATUS.cancelled]: 100,
  [UPLOAD_FILE_STATUS.failed]: 100,
};

export const VALIDATION_TYPE = {
  uploading: 'uploading',
  field_mapping: 'field_mapping',
  field_validation: 'field_validation',
  data_mapping: 'data_mapping',
  data_validation: 'data_validation',
  ready_for_import: 'ready_for_import',
  import: 'import',
};

export const VALIDATION_LABEL = {
  uploading: 'Validation Summary',
  field_mapping: 'Field Mapping',
  field_validation: 'Field Check',
  data_mapping: 'Data Mapping',
  data_validation: 'Data Check',
  ready_for_import: 'Ready for Import',
  import: 'import',
};

export const UPLOAD_ERROR_TYPE = {
  xml_file_invalid: 'Invalid XML file',
  certificate_file_empty: 'Empty File',
  upload_interrupted: 'Interrupted Upload',
  ftp_connection_error: 'FTP Failed to connect',
  ftp_download_error: 'File failed to download',
  ftp_file_not_found: 'File does not exist in server',
  excel_date_format_cells_unsupported: 'Invalid Date Time Format',
};

export const FIELD_VALIDATION_ERROR_TYPE = {
  field_required: 'Field',
  sheet_required: 'Sheet',
};

export const RESOLVE_UPLOAD_TYPE = {
  field_mapping: 'field_mapping',
  field_validation: 'field_validation',
  data_mapping: 'data_mapping',
  data_validation: 'data_validation',
};

export const VALIDATION_HIERARCHY = {
  upload: 0,
  field_mapping: 1,
  field_validation: 2,
  data_mapping: 3,
  data_validation: 4,
  ready_for_import: 5,
  import: 6,
};

export const SHEET_FIELD = {
  sites: 'Certification Additional Sites',
  standards: 'Certification Standard & Scheme',
};

export const SHEET_FIELD_XML = {
  sites: 'certification_additional_sites',
  standards: 'certification_standard_and_scheme',
};

export const SYSTEM_FIELD = {
  cert_unique_id: 'Certification Identity Number',
  cert_number: 'Certificate Number',
  cert_type: 'Certification Type',
  cert_scope: 'Certification Scope',
  cert_status: 'Certification Status',
  cert_issue_date: 'Certification Issue Date',
  cert_expiry_date: 'Certification Expiry Date',
  cert_orig_issue_date: 'Certificate Original Issue Date',
  cert_in: 'Certification Identity Number',
  ce_name: 'Certified Entity Name',
  ce_en_name: 'Certified Entity English Name',
  ce_trading_name: 'Certified Entity Trading Name',
  ce_unique_id: 'Certified Entity Unique ID',
  ce_city: 'Certified Entity City',
  ce_website: 'Certified Entity Website',
  ce_state: 'Certified Entity State',
  ce_street: 'Certified Entity Street',
  ce_country: 'Certified Entity Country/Economy',
  ce_post_code: 'Certified Entity Zipcode/Postcode',
  cb_name: 'Certification Body Name',
  cb_acronym: 'Certification Body Acronym',
  cb_identity_number: 'Certification Body Identity Number',
  ab_name: 'Accreditation Body Name',
  ab_acronym: 'Accreditation Body Acronym',
  city: 'Additional Site City',
  scope: 'Additional Site Scope',
  state: 'Additional Site State',
  street: 'Additional Site Street',
  country: 'Additional Site Country/Economy',
  post_code: 'Additional Site Post Code',
  cert_st_sch: 'Certification Standard & Scheme',
  sch_name: 'Scheme Name',
  st_name: 'Standard Name',
  ce_confidential: 'Confidential Certified Entity',
};

export const SYSTEM_FIELD_XML = {
  cert_unique_id: 'certificate_identity_number',
  cert_number: 'certificate_number',
  cert_type: 'certification_type',
  cert_scope: 'certification_scope',
  cert_status: 'certification_status',
  cert_issue_date: 'certification_issue_date',
  cert_expiry_date: 'certification_expiry_date',
  cert_orig_issue_date: 'certification_original_issue_date',
  cert_in: 'certificate_identity_number',
  ce_name: 'certified_entity_name',
  ce_en_name: 'certified_entity_english_name',
  ce_trading_name: 'certified_entity_trading_name',
  ce_unique_id: 'certified_entity_unique_id',
  ce_confidential: 'confidential_certified_entity',
  ce_city: 'certified_entity_city',
  ce_website: 'certified_entity_website',
  ce_state: 'certified_entity_state',
  ce_street: 'certified_entity_street',
  ce_country: 'certified_entity_country',
  ce_post_code: 'certified_entity_zip_code',
  cb_name: 'certification_body_name',
  cb_acronym: 'certification_body_acronym',
  cb_identity_number: 'certification_body_identity_number',
  ab_name: 'accreditation_body_name',
  ab_acronym: 'accreditation_body_acronym',
  city: 'city',
  scope: 'scope',
  state: 'state',
  street: 'street',
  country: 'country',
  post_code: 'zip_code',
  cert_st_sch: 'certification_standard_and_scheme',
  sch_name: 'scheme_name',
  st_name: 'standard_name',
};

export const IMPORT_MANAGEMENT_ERROR_CODE = {
  data_char_limit_exceeded: 'data_char_limit_exceeded',
  data_required: 'data_required',
  cin_field_mismatch: 'cin_field_mismatch',
  data_in: 'data_in',
  data_wrong_date_format: 'data_wrong_date_format',
  cb_accreditation_invalid: 'cb_accreditation_invalid',
  ab_acronym_mismatch: 'ab_acronym_mismatch',
  ab_cb_accreditation_invalid: 'ab_cb_accreditation_invalid',
  cb_accreditation_status_invalid: 'cb_accreditation_status_invalid',
  certificate_expiry_date_invalid: 'certificate_expiry_date_invalid',
  certificate_issue_date_invalid: 'certificate_issue_date_invalid',
  certificate_active_status_expiry_date_invalid:
    'certificate_active_status_expiry_date_invalid',
  certificate_expired_status_expiry_date_invalid:
    'certificate_expired_status_expiry_date_invalid',
  certificate_standard_scheme_required: 'certificate_standard_scheme_required',
  ce_ceuid_address_mismatch: 'ce_ceuid_address_mismatch',
  certificate_cuid_mismatch: 'certificate_cuid_mismatch',
  certificate_cuid_standard_mismatch: 'certificate_cuid_standard_mismatch',
  certificate_cuid_dates_mismatch: 'certificate_cuid_dates_mismatch',
  certificate_cuid_dates_standard_mismatch:
    'certificate_cuid_dates_standard_mismatch',
  data_excel_formula_forbidden: 'data_excel_formula_forbidden',
  certificate_cuid_sites_mismatch: 'certificate_cuid_sites_mismatch',
  certificate_cuid_dates_sites_mismatch:
    'certificate_cuid_dates_sites_mismatch',
  certificate_cuid_standard_sites_mismatch:
    'certificate_cuid_standard_sites_mismatch',
  certificate_cuid_dates_standard_sites_mismatch:
    'certificate_cuid_dates_standard_sites_mismatch',
  certificate_invalid_standard_scheme: 'certificate_invalid_standard_scheme',
  ce_multiple_ceuid_in_batch_file: 'ce_multiple_ceuid_in_batch_file',
  ce_ceuid_multiple_ce_in_batch_file: 'ce_ceuid_multiple_ce_in_batch_file',
  certificate_duplicate_cuid_in_batch_file:
    'certificate_duplicate_cuid_in_batch_file',
  certificate_multiple_cuid_in_batch_file:
    'certificate_multiple_cuid_in_batch_file',
  mncb_cb_link_invalid: 'mncb_cb_link_invalid',
  mncb_cb_accreditation_invalid: 'mncb_cb_accreditation_invalid',
  ce_ceuid_exists: 'ce_ceuid_exists',
  certificate_cuid_exists: 'certificate_cuid_exists',
};

export const IMPORT_MANAGEMENT_ERROR_CODE_MESSAGE = {
  [IMPORT_MANAGEMENT_ERROR_CODE['data_required']]: 'Missing mandatory data',
  [IMPORT_MANAGEMENT_ERROR_CODE['cin_field_mismatch']]:
    'Mismatched identifier: Certification Identity Number',
  [IMPORT_MANAGEMENT_ERROR_CODE['data_in']]:
    'Invalid Confidential Certified Entity flag',
  [IMPORT_MANAGEMENT_ERROR_CODE['data_wrong_date_format']]:
    'Format Issue: Invalid date format',
  [IMPORT_MANAGEMENT_ERROR_CODE['cb_accreditation_invalid']]:
    'Accreditation does not exist',
  [IMPORT_MANAGEMENT_ERROR_CODE['ab_acronym_mismatch']]:
    'AB Acronym is invalid',
  [IMPORT_MANAGEMENT_ERROR_CODE['ab_cb_accreditation_invalid']]:
    'The Certification Body does not have an accreditation',
  [IMPORT_MANAGEMENT_ERROR_CODE['cb_accreditation_status_invalid']]:
    'Accreditation is invalid',
  [IMPORT_MANAGEMENT_ERROR_CODE['certificate_expiry_date_invalid']]:
    'Discrepancy between Issue Date and Expiry Date',
  [IMPORT_MANAGEMENT_ERROR_CODE['certificate_issue_date_invalid']]:
    'Discrepancy between Issue Date and Original Issue Date',
  [IMPORT_MANAGEMENT_ERROR_CODE[
    'certificate_active_status_expiry_date_invalid'
  ]]: 'Discrepancy between Certificate Status and Expiry Date',
  [IMPORT_MANAGEMENT_ERROR_CODE[
    'certificate_expired_status_expiry_date_invalid'
  ]]: 'Discrepancy between Certificate Status and Expiry Date',
  [IMPORT_MANAGEMENT_ERROR_CODE['certificate_standard_scheme_required']]:
    'Missing Standard Name and Scheme Name',
  [IMPORT_MANAGEMENT_ERROR_CODE['ce_ceuid_address_mismatch']]:
    'Mismatched Certified Entity Unique ID',
  [IMPORT_MANAGEMENT_ERROR_CODE['certificate_cuid_mismatch']]:
    'Mismatched Certificate Unique ID',
  [IMPORT_MANAGEMENT_ERROR_CODE['certificate_cuid_standard_mismatch']]:
    'Mismatched Certificate Unique ID',
  [IMPORT_MANAGEMENT_ERROR_CODE['certificate_cuid_dates_mismatch']]:
    'Mismatched Certificate Unique ID',
  [IMPORT_MANAGEMENT_ERROR_CODE['certificate_cuid_dates_standard_mismatch']]:
    'Certificate Number already exist',
  [IMPORT_MANAGEMENT_ERROR_CODE['data_excel_formula_forbidden']]:
    'Invalid data format',
  [IMPORT_MANAGEMENT_ERROR_CODE['certificate_cuid_sites_mismatch']]:
    'Certificate Number already exist',
  [IMPORT_MANAGEMENT_ERROR_CODE['certificate_cuid_dates_sites_mismatch']]:
    'Certificate Number already exist',
  [IMPORT_MANAGEMENT_ERROR_CODE['certificate_cuid_standard_sites_mismatch']]:
    'Certificate Number already exist',
  [IMPORT_MANAGEMENT_ERROR_CODE[
    'certificate_cuid_dates_standard_sites_mismatch'
  ]]: 'Certificate Number already exist',
  [IMPORT_MANAGEMENT_ERROR_CODE['certificate_invalid_standard_scheme']]:
    'Invalid Standard and Scheme',
  [IMPORT_MANAGEMENT_ERROR_CODE['ce_multiple_ceuid_in_batch_file']]:
    'Certified Entity has multiple Certified Entity Unique ID (CEUID)',
  [IMPORT_MANAGEMENT_ERROR_CODE['ce_ceuid_multiple_ce_in_batch_file']]:
    'Certified Entity Unique ID (CEUID) has been assigned to multiple Certified Entity records',
  [IMPORT_MANAGEMENT_ERROR_CODE['certificate_duplicate_cuid_in_batch_file']]:
    'Certification Identity Number has been assigned to multiple Certificates',
  [IMPORT_MANAGEMENT_ERROR_CODE['certificate_multiple_cuid_in_batch_file']]:
    'Certificate has multiple Certification UNIQUE Identity Number (CUID)',
  [IMPORT_MANAGEMENT_ERROR_CODE['mncb_cb_link_invalid']]:
    'The Certification Body is not associated with the MNCB',
  [IMPORT_MANAGEMENT_ERROR_CODE['mncb_cb_accreditation_invalid']]:
    'Accreditation is invalid',
  [IMPORT_MANAGEMENT_ERROR_CODE['ce_ceuid_exists']]:
    'Certified Entity Unique ID already exists',
  [IMPORT_MANAGEMENT_ERROR_CODE['certificate_cuid_exists']]:
    'Certificate Unique ID already exists',
};

export const FILE_TYPES = {
  xml: 'xml',
  xlsx: 'excel',
  xls: 'excel',
};

export const FILE_TYPES_ACCEPTED = {
  excel: ['.xlsx'],
  xml: ['.xml'],
};

export const ACTIVITY_FILE_CODE = {
  ab_upload: 'ab_upload',
  ab_cb_upload: 'ab_cb_upload',
  ab_cb_xml: 'ab_cb_xml',
  ab_certs_upload: 'ab_certs_upload',
  ab_certs_xml: 'ab_certs_xml',
  cb_certs_upload: 'cb_certs_upload',
  cb_certs_xml: 'cb_certs_xml',
  mncb_certs_xml: 'mncb_certs_xml',
};

export const FILE_SKIP_CODE = {
  file: 'file',
  record: 'record',
};
export const FILE_SKIP_FILE_PROGRESS = {
  value: 100,
  color: 'secondary',
  text: '--',
};
export const FILE_SKIP_RECORD_PROGRESS = {
  value: 100,
  color: 'warning',
  text: '100%',
};

export const MAPPING_TYPE = {
  sheet: 'sheet',
  field: 'field',
};

export const MAPPING_TYPE_LABEL = {
  sheet: 'Sheet Name',
  field: 'Field Name',
};

export const MAPPING_STATUS = {
  active: 'active',
  inactive: 'inactive',
};

export const MAPPING_COLOR = {
  active: 'success',
  inactive: 'secondary',
};

export const MAPPING_LABEL = {
  active: 'Mapped',
  inactive: 'Unmapped',
};

const IMPORT_MANAGEMENT_DOCS_URL_PREFIX = 'https://support.iafcertsearch.org/';
const DATA_MANAGEMENT_DOCS_URL_PREFIX = 'https://developer.iafcertsearch.org/';

export const IMPORT_MANAGEMENT_DOCS = {
  ab_data_import: urljoin(
    IMPORT_MANAGEMENT_DOCS_URL_PREFIX,
    'accreditation-bodies/data-management/import-certification'
  ),
  cb_data_import: urljoin(
    IMPORT_MANAGEMENT_DOCS_URL_PREFIX,
    'certification-bodies/data-management/data-import'
  ),
  mncb_data_import: urljoin(
    IMPORT_MANAGEMENT_DOCS_URL_PREFIX,
    'mncb/data-management/import-certification/data-import-methods'
  ),
  ab_ftp_settings: urljoin(
    IMPORT_MANAGEMENT_DOCS_URL_PREFIX,
    'accreditation-bodies/data-management/import-certification/ftp-settings'
  ),
  cb_ftp_settings: urljoin(
    IMPORT_MANAGEMENT_DOCS_URL_PREFIX,
    'certification-bodies/data-management/data-import/ftp-settings'
  ),
  mncb_ftp_settings: urljoin(
    IMPORT_MANAGEMENT_DOCS_URL_PREFIX,
    'mncb/data-management/import-certification/ftp-settings'
  ),
  ab_file_upload: urljoin(
    IMPORT_MANAGEMENT_DOCS_URL_PREFIX,
    'accreditation-bodies/data-management/import-certification/file-upload'
  ),
  cb_file_upload: urljoin(
    IMPORT_MANAGEMENT_DOCS_URL_PREFIX,
    'certification-bodies/data-management/data-import/data-import-methods/file-upload'
  ),
  mncb_file_upload: urljoin(
    IMPORT_MANAGEMENT_DOCS_URL_PREFIX,
    'mncb/data-management/import-certification/data-import-methods/file-upload'
  ),
  ab_ftp_server: urljoin(
    IMPORT_MANAGEMENT_DOCS_URL_PREFIX,
    'accreditation-bodies/data-management/import-certification/data-import-methods/ftp'
  ),
  cb_ftp_server: urljoin(
    IMPORT_MANAGEMENT_DOCS_URL_PREFIX,
    'certification-bodies/data-management/data-import/data-import-methods/ftp'
  ),
  mncb_ftp_server: urljoin(
    IMPORT_MANAGEMENT_DOCS_URL_PREFIX,
    'mncb/data-management/import-certification/data-import-methods/ftp'
  ),
  ab_generate_api_key: urljoin(
    IMPORT_MANAGEMENT_DOCS_URL_PREFIX,
    'accreditation-bodies/data-management/import-certification/data-import-methods/api'
  ),
  cb_generate_api_key: urljoin(
    DATA_MANAGEMENT_DOCS_URL_PREFIX,
    'docs/api-access/getting-started'
  ),
  ab_api_integration: urljoin(
    IMPORT_MANAGEMENT_DOCS_URL_PREFIX,
    'accreditation-bodies/data-management/import-certification/data-import-methods/api'
  ),
  cb_api_integration: urljoin(
    IMPORT_MANAGEMENT_DOCS_URL_PREFIX,
    'certification-bodies/data-management/data-import/data-import-methods/api'
  ),
  mncb_api_integration: urljoin(
    IMPORT_MANAGEMENT_DOCS_URL_PREFIX,
    'api-integration/multi-national-certification-body-apis/certification-api'
  ),
  ab_field_mapping: urljoin(
    IMPORT_MANAGEMENT_DOCS_URL_PREFIX,
    'accreditation-bodies/error-handling/resolve-field-mapping-issues'
  ),
  cb_field_mapping: urljoin(
    IMPORT_MANAGEMENT_DOCS_URL_PREFIX,
    'certification-bodies/error-handling/resolve-field-mapping-issues'
  ),
  ab_field_validation: urljoin(
    IMPORT_MANAGEMENT_DOCS_URL_PREFIX,
    'certification-bodies/error-handling/resolve-field-check-issues'
  ),
  cb_field_validation: urljoin(
    IMPORT_MANAGEMENT_DOCS_URL_PREFIX,
    'accreditation-bodies/error-handling/resolve-field-check-issues'
  ),
  ab_data_mapping: urljoin(
    IMPORT_MANAGEMENT_DOCS_URL_PREFIX,
    'accreditation-bodies/error-handling/resolve-data-check-issues'
  ),
  cb_data_mapping: urljoin(
    IMPORT_MANAGEMENT_DOCS_URL_PREFIX,
    'certification-bodies/error-handling/resolve-data-mapping-issues'
  ),
  ab_data_validation: urljoin(
    IMPORT_MANAGEMENT_DOCS_URL_PREFIX,
    'accreditation-bodies/error-handling/resolve-data-check-issues'
  ),
  cb_data_validation: urljoin(
    IMPORT_MANAGEMENT_DOCS_URL_PREFIX,
    'certification-bodies/error-handling/resolve-data-check-issues'
  ),
  ab_global_data_mapping: urljoin(
    IMPORT_MANAGEMENT_DOCS_URL_PREFIX,
    'accreditation-bodies/error-handling/resolve-data-mapping-issues'
  ),
  cb_global_data_mapping: urljoin(
    IMPORT_MANAGEMENT_DOCS_URL_PREFIX,
    'certification-bodies/data-management/data-import/global-mapping/data-mapping'
  ),
  cb_migration_batch_upload: urljoin(
    IMPORT_MANAGEMENT_DOCS_URL_PREFIX,
    'certification-bodies/data-management/data-import/data-import-methods/file-upload#file-upload-rules'
  ),
  mncb_migration_batch_upload: urljoin(
    IMPORT_MANAGEMENT_DOCS_URL_PREFIX,
    'mncb/data-management/import-certification/data-import-methods/file-upload'
  ),
  ab_migration_batch_upload: urljoin(
    IMPORT_MANAGEMENT_DOCS_URL_PREFIX,
    'accreditation-bodies/data-management/import-certification/data-import-methods/file-upload#file-upload-rules'
  ),
  ab_migration_auto_import: urljoin(
    IMPORT_MANAGEMENT_DOCS_URL_PREFIX,
    'accreditation-bodies/data-management/import-certification/import-settings'
  ),
  cb_migration_auto_import: urljoin(
    IMPORT_MANAGEMENT_DOCS_URL_PREFIX,
    'certification-bodies/data-management/data-import/import-settings'
  ),
  mncb_migration_auto_import: urljoin(
    IMPORT_MANAGEMENT_DOCS_URL_PREFIX,
    'mncb/data-management/import-certification/import-settings'
  ),
  ab_migration_error_handling: urljoin(
    IMPORT_MANAGEMENT_DOCS_URL_PREFIX,
    'accreditation-bodies/error-handling/error-handling'
  ),
  cb_migration_error_handling: urljoin(
    IMPORT_MANAGEMENT_DOCS_URL_PREFIX,
    'certification-bodies/error-handling/error-handling'
  ),
  mncb_migration_error_handling: urljoin(
    IMPORT_MANAGEMENT_DOCS_URL_PREFIX,
    'mncb/error-handling/error-handling'
  ),
};

// in ms
export const RELOAD_DURATION = 15000;
export const SUMMARY_RELOAD_DURATION = 10 * 1000; // 10 seconds
export const MIN_PROCESSING_PAYMENT_RELOAD_DURATION = 15 * 1000; // 15 seconds
export const DEFAULT_PROCESSING_PAYMENT_RELOAD_DURATION = 3600 * 1000; // 1 hour
